import { Injectable } from '@angular/core';
import { ConfigService } from '../common/config.service';
import { HttpClient } from '@angular/common/http';
import { ForgotPasswordPayload, LoginOrganisationApiOutputModel, LoginOrganisationApiPayload, RegisterCustomerPayload, RegisterCustomerResponse, ResetPasswordPayload, sendOtpOutputModel, SendOtpPayload, VerifyOtpApiSuccessModel, VerifyOtpPayload, VerifyResetPasswordPAyload } from '../../models/api/login.model';
import { ServiceCustomerInfoApiOutputModel } from '../../models/api/customer.model';
import { CommonApiOutputModel } from '../../models/api/common.model';
import { BehaviorSubject, Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  private token = '';
  constructor(
    private configServ: ConfigService,
    private http: HttpClient
  ) { }

  private loggedIn$ = new BehaviorSubject<boolean>(true);

  sendOtp(payload: SendOtpPayload) {
    return this.http.post<sendOtpOutputModel>(
      `${this.configServ.apiRoutes.SEND_OTP}`,
      payload,
    )
  }

  verifyOtp(payload: VerifyOtpPayload) {
    return this.http.post<VerifyOtpApiSuccessModel>(
      `${this.configServ.apiRoutes.VERIFY_OTP}`,
      payload,
    )
  }

  registerCustomer(data: RegisterCustomerPayload) {
    let formData = this.configServ.convertToFormdata(data)
    return this.http.post<RegisterCustomerResponse>(this.configServ.apiRoutes.REGISTER_CUSTOMER, formData);
  }

  customerDetails(data: any) {
    // let formData = this.configServ.convertToFormdata(data)
    return this.http.post<ServiceCustomerInfoApiOutputModel>(this.configServ.apiRoutes.CUSTOMER_DETAILS, data);

  }
  logout(payload: { token: string }) {
    return this.http.post<any>(this.configServ.apiRoutes.LOGOUT, payload);
  }

  loginOrganisation(payload: LoginOrganisationApiPayload) {
    return this.http.post<LoginOrganisationApiOutputModel>(
      this.configServ.apiRoutes.LOGIN_ORGANISATION,
      payload
    );
  }

  contactToAdmin(payload: any) {
    return this.http.post<any>(
      this.configServ.apiRoutes.CONTACT_TO_ADMIN,
      payload
    );
  }

  forgotPassword(forgotData: ForgotPasswordPayload) {
    return this.http.post<any>(this.configServ.apiRoutes.FORGOT_PASSWORD, forgotData);
  }

  resetPassword(resetPasswordData: ResetPasswordPayload) {
    return this.http.post<CommonApiOutputModel>(this.configServ.apiRoutes.RESET_PASSWORD, resetPasswordData);
  }

  verifyResetPassword(verifyResetPasswordData: VerifyResetPasswordPAyload) {
    return this.http.post<any>(this.configServ.apiRoutes.VERIFY_RESET_PASSWORD_TOKEN, verifyResetPasswordData);
  }

  setToken(token: string) {
    this.token = token;
  }

  getToken(): string {
    return this.token;
  }

  clear() {
    this.token = '';
  }

  setLoggedInState(state: boolean) {
    this.loggedIn$.next(state);
  }

  getLoggedInState(): Observable<boolean> {
    return this.loggedIn$.asObservable();
  }

  isLoggedIn(): boolean {
    return this.loggedIn$.value;
  }
}
